module.exports = __webpack_public_path__ + "assets/expand-white.84a48ed69117b7c743ac5f79df2beb3c.svg";